import { useCallback, useContext, useState } from 'react'

import { GridRowHeightReturnValue } from '@mui/x-data-grid-pro'
import { PaginatedFieldsContext } from './PaginatedFieldsProvider'
import { PaginatedFieldsTable } from './PaginatedFieldsTable'
import { PaginatedFieldsTableProps } from './PrivatePaginatedFieldsTableTypes'

export type ReadOnlyFieldsTableProps = Omit<
  PaginatedFieldsTableProps,
  'selectionModel' | 'onSelectionModelChange' | 'handlePageChange' | 'checkboxSelection'
>

export const ReadOnlyPaginatedFieldsTable = (dataGridProProps: ReadOnlyFieldsTableProps) => {
  const { setPage } = useContext(PaginatedFieldsContext)
  const [pageSize, setPageSize] = useState(10)

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
  }

  const getRowHeight = useCallback(() => 'auto' as GridRowHeightReturnValue, [])

  return (
    <PaginatedFieldsTable
      handlePageChange={handlePageChange}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      getRowHeight={getRowHeight}
      {...dataGridProProps}
      disableSelectionOnClick
    />
  )
}
